import permission from "./permission"
export default {
    permission
}